<div class="mat-typography full-height full-width">
    <router-outlet></router-outlet>
</div>
